import { FC } from 'react';
import { EDataSourceStatus } from '@/models/dataSource';
import { BadgeWithDot } from '@/lib';

type DataSourceStatusBadgeProps = {
  status: EDataSourceStatus;
};

export const DataSourceStatusBadge: FC<DataSourceStatusBadgeProps> = ({ status }) => {
  switch (status) {
    case EDataSourceStatus.ACTIVE:
      return <BadgeWithDot label='ALL:active' dotColorClassName='bg-green-600' />;
    case EDataSourceStatus.ACTIVATING:
      return <BadgeWithDot label='ALL:waitingActivation' dotColorClassName='bg-orange-600' />;
    case EDataSourceStatus.PENDING:
      return <BadgeWithDot label='ALL:activating' dotColorClassName='bg-yellow-600' />;
    case EDataSourceStatus.CONFIGURATION_REQUIRED:
      return <BadgeWithDot label='ALL:configurationRequired' dotColorClassName='bg-red-600' />;
    case EDataSourceStatus.ERROR:
      return <BadgeWithDot label='ALL:error' dotColorClassName='bg-red-600' />;
    default:
      return null;
  }
};
